module.exports = __webpack_public_path__ + "img/sendButton.23ad1f36.svg";